import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/icons/download-icon.svg'
import _imports_1 from '@/assets/icons/download-icon.svg'
import _imports_2 from '@/assets/images/billingHistoryempty.png'


const _withScopeId = n => (_pushScopeId("data-v-3fc8e5e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "billing_history__wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "billing_history__header"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "billing_history__title" }, "Billing History")
], -1))
const _hoisted_4 = { class: "download__btn" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_18 = {
  key: 2,
  class: "empty-screen"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-screen__inner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "empty-screen__image" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "empty-screen__header" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Your billing history is currently empty."),
    /*#__PURE__*/_createElementVNode("p", null, " Start making transactions to see your billing records here and keep track of your payments! ")
  ])
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full tw-w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_Text = _resolveComponent("Text")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          ($setup.billingHistoryList?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_btn, {
                    class: "button button-orange",
                    width: "100%",
                    onClick: $setup.downloadPdf
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" Download PDF ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.billingHistoryList?.length)
            ? (_openBlock(), _createBlock(_component_v_table, {
                key: 1,
                class: "tw-pt-8 tw-pb-4 tw-box-border tw-bg-transparent no-scrollbar"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_6, [
                        _createVNode(_component_Text, {
                          variant: "p",
                          class: "tw-uppercase"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Date")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("th", _hoisted_7, [
                        _createVNode(_component_Text, {
                          variant: "p",
                          whiteSpace: "nowrap",
                          class: "tw-uppercase"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Description")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("th", _hoisted_8, [
                        _createVNode(_component_Text, {
                          variant: "p",
                          whiteSpace: "nowrap",
                          class: "tw-uppercase"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Amount")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("th", _hoisted_9, [
                        _createVNode(_component_Text, {
                          variant: "p",
                          whiteSpace: "nowrap",
                          class: "tw-uppercase"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Status")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("th", _hoisted_10, [
                        _createVNode(_component_Text, {
                          variant: "p",
                          whiteSpace: "nowrap",
                          class: "tw-uppercase"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("invoice")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.billingHistoryList, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        class: "tw-cursor-pointer"
                      }, [
                        _createElementVNode("td", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_Text, {
                              class: "tw-whitespace-nowrap",
                              variant: "p"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item?.dateCreated ? $setup.formatDate(item?.dateCreated) : "--"), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_13, [
                          _createVNode(_component_Text, {
                            class: "tw-whitespace-nowrap",
                            variant: "p"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item?.description), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("td", _hoisted_14, [
                          _createVNode(_component_Text, {
                            class: "tw-whitespace-nowrap",
                            variant: "p"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("£" + _toDisplayString(item?.amount ? item?.amount : "0"), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("td", _hoisted_15, [
                          _createVNode(_component_Text, {
                            class: "tw-whitespace-nowrap tw-inline-block tw-text-white tw-bg-[#1fb27a] tw-py-[2px] tw-px-[8px] tw-rounded-md",
                            variant: "p"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item?.status || "--"), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("td", _hoisted_16, [
                          _createVNode(_component_v_icon, {
                            onClick: ($event: any) => ($setup.onClickDownloadInvoice(item?.id)),
                            color: "#80829F",
                            class: "card__delete"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_17
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!$setup.billingHistoryList?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ($setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_Loader, { show: $setup.isLoading }, null, 8, ["show"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}